module.exports = __webpack_public_path__ + "img/horizontal_4_5_pp3_3016.fe792706.png";